import _ from 'lodash'

const PROPERTY_TO_REMOVE_PREFIX = '_'

const markPropertyToRemove = (propName: string): string => {
    return `${PROPERTY_TO_REMOVE_PREFIX}${propName}`
}

const isPropertyToRemove = (propName: string): boolean => {
    return _.startsWith(propName, PROPERTY_TO_REMOVE_PREFIX)
}

const removePropertyToRemovePrefix = (cssProp: string | undefined): string | undefined => {
    return cssProp?.replace(PROPERTY_TO_REMOVE_PREFIX, '')
}

const rgbToHex = (color: string): string => {
    const rgbRegex: RegExp = /^rgba?\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})(?:,\s*([\d.]+))?\)$/
    const match = color.match(rgbRegex)

    if (!match) {
        return color
    }

    const r = parseInt(match[1], 10)
    const g = parseInt(match[2], 10)
    const b = parseInt(match[3], 10)
    const a = match[4] !== undefined ? parseFloat(match[4]) : 1

    const hexR = r.toString(16).padStart(2, '0')
    const hexG = g.toString(16).padStart(2, '0')
    const hexB = b.toString(16).padStart(2, '0')
    const hexA = Math.round(a * 255)
        .toString(16)
        .padStart(2, '0')

    return `#${hexR}${hexG}${hexB}${a < 1 ? hexA : ''}`
}

const splitWithRgb = (value: string, delimiter: string = ' '): string[] => {
    const delimiterRegex = delimiter.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')
    const rgbSafeRegex = new RegExp(
        `(?:rgb(a)?\\(\\d{1,3},\\s*\\d{1,3},\\s*\\d{1,3}(?:,\\s*[\\d.]+)?\\)|[^${delimiterRegex}])+`,
        'g'
    )
    return value.match(rgbSafeRegex) ?? []
}

export {markPropertyToRemove, isPropertyToRemove, removePropertyToRemovePrefix, rgbToHex, splitWithRgb}
